import { render, staticRenderFns } from "./BotSettingsHome.vue?vue&type=template&id=01e6b5b2&"
import script from "./BotSettingsHome.vue?vue&type=script&lang=js&"
export * from "./BotSettingsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports